import React from "react";

import styles from "./ToggleButton.module.scss";

interface ToggleButtonProps {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

export function ToggleButton(props: ToggleButtonProps) {
  return (
    <div
      role="checkbox"
      aria-checked={props.active}
      className={[styles.toggle, props.active ? styles.active : ""].join(" ")}
      onClick={(e) => props.onClick()}
    >
      {props.children}
    </div>
  );
}
